import React from 'react'
import type { LogoProps } from './types'

const Logo = ({ className = '', hasLogo, logoToDisplay }: LogoProps) => {
  return (
    //Todo: Check later to see if this class will be usefull in the future
    <div className={`${className}-logo ${hasLogo ? 'hasLogo' : ''}`}>
      {hasLogo ? (
        <img
          alt={`Logo: ${logoToDisplay}`}
          className={`${className}-logo-image`}
          src={`${logoToDisplay}?format=webp`}
        />
      ) : (
        <p className={`${className}-logo-title`}>{logoToDisplay}</p>
      )}
    </div>
  )
}

export default Logo
